import { Switch, Route } from "react-router-dom";

import Home from "features/administration/pages/unused/Home";
import Tables from "features/administration/pages/unused/Tables";
import Billing from "features/administration/pages/unused/Billing";
import Profile from "features/administration/pages/unused/Profile";

import Main from "shared/components/layout/muse-layout/Main";
import "shared/assets/styles-muse/main.css";
import "shared/assets/styles-muse/responsive.css";
import SignIn from "features/administration/pages/unused/SignIn";
import UsersManagement from "features/administration/pages/UsersManagement";
import OrgsManagement from "features/administration/pages/OrgsManagement";
import { OrganizationsDataProvider } from "features/administration/contexts/OrgsDataProvider";
import SignUp from "features/administration/pages/unused/SignUp";
import RobotsAministrator from "features/administration/pages/RobotsAdministrator";
import RobotTypesManagement from "features/administration/pages/RobotTypesManagement";
import JoyControlMappingsManagement from "features/administration/pages/JoyControlMappingsManagement";

function AdminApp() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/admin/sign-in" component={SignIn} />
        <Route exact path="/admin/sign-up" component={SignUp} />
        <Main>
          <Route exact path="/admin/orgs">
            <OrganizationsDataProvider>
              <OrgsManagement />
            </OrganizationsDataProvider>
          </Route>
          <Route exact path="/admin/robots" component={RobotsAministrator} />
          <Route exact path="/admin/robot-types" component={RobotTypesManagement} />
          <Route exact path="/admin/joy-control-mappings" component={JoyControlMappingsManagement} />
          <Route exact path="/admin/users" component={UsersManagement} />

          <Route exact path="/admin" component={Home} />
          <Route exact path="/admin/dashboard" component={Home} />
          <Route exact path="/admin/tables" component={Tables} />
          <Route exact path="/admin/billing" component={Billing} />
          {/* <Route exact path="/rtl" component={Rtl} /> */}
          <Route exact path="/admin/profile" component={Profile} />
          {/* <Redirect from="/admin/*" to="/admin/dashboard" /> */}
        </Main>
      </Switch>
    </div>
  );
}

export default AdminApp;
